import React, { useState } from "react"
import * as styles from "./Navbar.module.css"
import MenuToggle from "./MenuToggle"
import { Link } from "gatsby"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@material-ui/core"
const MobileNavLinks = () => {
  const [isOpen, setOpen] = useState(false)
  return (
    <div className={styles.mobile__navlinks_container}>
      <MenuToggle isOpen={isOpen} toggle={() => setOpen(!isOpen)} />
      {isOpen && (
        <ul className={styles.mobile__links_wrapper}>
          <li className={styles.mobile__link_item}>
            <Link to="/">Home</Link>
          </li>
          <li
            className={styles.mobile__link_item}
            style={{ marginLeft: "0px" }}
          >
            <Accordion
              style={{
                backgroundColor: "transparent",
                border: "none",
                boxShadow: "none",
                margin: "10px 0",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{ textAlign: "left" }}
              >
                Choose a Field
              </AccordionSummary>
              <AccordionDetails
                style={{ flexFlow: "column", textAlign: "left" }}
              >
                <Link style={{ margin: "5px 0" }} to="/Core">
                  Core
                </Link>
                <Link style={{ margin: "5px 0" }} to="/Consultancy">
                  Consultancy
                </Link>
                <Link style={{ margin: "5px 0" }} to="/Entrepreneurship">
                  Entrepreneurship
                </Link>
                <Link style={{ margin: "5px 0" }} to="/Finance">
                  Finance
                </Link>
                <Link style={{ margin: "5px 0" }} to="/IT">
                  IT
                </Link>
                <Link style={{ margin: "5px 0" }} to="/Miscellaneous">
                  Miscellaneous
                </Link>
                <Link style={{ margin: "5px 0" }} to="/Product Management">
                  Product Management
                </Link>
                <Link style={{ margin: "5px 0" }} to="/Research">
                  Research
                </Link>
                <Link style={{ margin: "5px 0" }} to="/Supply Chain Management">
                  Supply Chain Management
                </Link>
              </AccordionDetails>
            </Accordion>
          </li>
          <li className={styles.mobile__link_item}>
            <Link to="/testimonials">Testimonials</Link>
          </li>
          <li className={styles.mobile__link_item}>
            <Link to="/about">About Us</Link>
          </li>
          <li className={styles.mobile__link_item}>
            <AnchorLink
              to="/#contactus"
              onAnchorLinkClick={evt => {
                setOpen(false)
              }}
            >
              Contact Us
            </AnchorLink>
          </li>
        </ul>
      )}
    </div>
  )
}
export default MobileNavLinks
